import { createFileRoute } from "@tanstack/react-router";
import { BrasilChannelLanding } from "@/components/match/brasil/BrasilChannelLanding";
import { BRASIL_FAQ_BY_CHANNEL, buildFaqJsonLd } from "@/components/growth/BrasilFaq";

export const Route = createFileRoute("/brasil/globoplay")({
  head: () => ({
    meta: [
      { title: "VerseSport Brasil + Globoplay — Segunda tela com previsões ao vivo" },
      { name: "description", content: "Use o VerseSport como segunda tela do Globoplay: previsões, Nation Wars, Audio Sync e estatísticas em tempo real." },
      { property: "og:title", content: "VerseSport Brasil + Globoplay — Segunda tela" },
      { property: "og:description", content: "Previsões, Nation Wars e Audio Sync compatível com o Globoplay." },
      { property: "og:url", content: "https://versesport.com/brasil/globoplay" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://versesport.com/brasil/globoplay" }],
    scripts: [{
      type: "application/ld+json",
      children: JSON.stringify(buildFaqJsonLd(BRASIL_FAQ_BY_CHANNEL.globoplay)),
    }],
  }),
  component: () => (
    <BrasilChannelLanding channelId="globoplay" channelName="Globoplay" intro="Acompanhe seus jogos no Globoplay com o VerseSport como segunda tela: previsões, ranking da torcida e Audio Sync sem spoilers." />
  ),
});